import React, { PureComponent } from 'react';
import { Animated, StyleSheet, View } from 'react-native';
import Theme from '../../theme';

interface IProps {
  step: number,
  progressBarContainer?: any
}

interface IState {
  animation: Animated.Value;
}

const TOTAL_STEPS = 6;

export class OnBoardingProgress extends PureComponent<IProps, IState> {
  state = {
    animation: new Animated.Value(0)
  }

  public componentDidMount = () => {
    const { animation } = this.state;
    const { step } = this.props;

    Animated.timing(animation, {
      toValue: (step / TOTAL_STEPS) * 100,
      duration: 500,
    } as any).start();
  }


  public render() {
    const { animation } = this.state;
    const width = animation.interpolate({
      inputRange: [0, 100],
      outputRange: ['0%', '100%'],
      extrapolate: 'extend'
    })

    return (
      <View style={[styles.container, this.props.progressBarContainer]}>
        <Animated.View style={[
          StyleSheet.absoluteFill, {
            width,
            backgroundColor: Theme.PRIMARY,
          }]} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    height: 10,
    width: '100%',
    backgroundColor: Theme.GREY_LIGHT,
  }
})
